import { EDUCATION_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import { LEARNING_TYPE_LABELS, SPECIAL_OFFERS_LABELS } from '../constants/labels.js';
import { LEARNING_TYPES_TITLES, SPECIAL_TAB_TO_TITLE_MAP } from '../constants/titles.js';

const getTabTitleTo = ({ type, subtype }) => {
    if (type === EDUCATION_OFFERS.learning && subtype) {
        return LEARNING_TYPES_TITLES[subtype];
    }
    return SPECIAL_TAB_TO_TITLE_MAP[type];
};
const getTabTitle = ({ type, subtype }) => {
    if (type === EDUCATION_OFFERS.learning && subtype) {
        return LEARNING_TYPE_LABELS[subtype];
    }
    return SPECIAL_OFFERS_LABELS[type];
};

export { getTabTitle, getTabTitleTo };
//# sourceMappingURL=getTitle.js.map
